import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import {
    DKLabel,
    Toggle,
    DKIcon,
    DKButton,
    DKInput,
    DKCheckMark,
    DKLine,
    showLoader,
    removeLoader,
    showToast,
    showAlert,
    TOAST_TYPE,
    INPUT_VIEW_DIRECTION
} from "deskera-ui-library";
import INTaxService from '../../../../services/compliance/IN/IntaxSerivce';
import INComplianceService from "../../../../services/compliance/INComplianceService";
import RouteManager from "../../../../managers/RouteManager";
import { PAGE_ROUTES } from "../../../../managers/RouteManager";
import { TENANT, TenantService } from "../../../../managers/TenantManagerService";
import { DATE_FORMAT, INPUT_TYPE, IN_TAX_REGIME_OPTIONS } from "../../../../constants/Constant";
import ic_info_warning from "../../../../assets/icons/ic_info_gray.svg";
import ic_delete from "../../../../assets/icons/ic_delete.png";
import { Countries, IN_STATES } from "../../../../constants/CountryConstant";
import { deepClone } from "../../../../utility/Utility";
import { PAN_REGEX_PATTERN } from "../../../../constants/RegexConstants";
import moment from "moment";
import AppManager from "../../../../managers/AppManager";
import EmployeeListService from "../../../../services/EmployeeListService";
import { getQueryParam } from "../../../../managers/common/CommonUtil";
import { INVESTMENT_STAGE } from "./InvestmentConstants";
import { isViewportLarge } from "../../../../utility/ViewportSizeUtils";
import PermissionUtils, { ACTION, MODULE } from "../../../user-permissions/PermissionUtils";

function MyITDeclaration(props) {
    const history = useHistory();

    const INVESTMENT_STATUS = {
        DRAFT: "DRAFT",
        SUBMITTED: "SUBMITTED",
        DECLARATION: "DECLARATION",
        PENDING:"PENDING"
    };

    const employeeData = getQueryParam(props.location, "employeeData");
    const userId = props.userId || getQueryParam(props.location, "id");
    const employeeName = props.employeeName || getQueryParam(props.location, "name");
    const isMyDeclaration = TenantService.get(TENANT.USER_ID) === userId;

    const SECTION = {
        FINANCIAL_YEAR: "financialYear",
        REGIME: "regime",
        HOUSE_RENT: "houseRent",
        HOME_LOAN: "homeLoan",
        RENTAL_INCOME: "rentalIncome",
        INVESTMENT_80C: "investment80C",
        INVESTMENT_80D: "investment80D",
        OTHER_INVESTMENT: "otherInvestment",
        OTHER_INCOME: "otherIncome"
    };

    const METRO_CITIES = ["110", "400", "600", "700"];

    const width = "25%";
    const marginRight = "5%";

    const getFinancialYears = () => {
        const years = [];

        const todayYear = moment().year();
        const todayMonth = moment().month();

        let startYear = todayMonth > moment().month("March").month() ? todayYear : todayYear - 1;
        const endYear = todayMonth > moment().month("March").month() ? todayYear + 1 : todayYear;

        const dateOfCreation = TenantService.get(TENANT.DATE_OF_CREATION);
        if (dateOfCreation) {
            const dateOfCreationYear = moment(dateOfCreation, DATE_FORMAT.YYYYMMDD).year();
            if (dateOfCreationYear < startYear) {
                startYear = dateOfCreationYear;
            }
        }

        while(startYear !== endYear) {
            years.push(String().concat(startYear, " - ", startYear + 1));
            startYear++;
        }

        return years;
    }

    const getFinancialYearStartDate = () => {
        let startDate = null;

        const selectedFinancialYear = getSelectFieldValue(financialYear.financialYear, financialYears);
        if (selectedFinancialYear) {
            startDate = moment([selectedFinancialYear.split(" - ")[0], 3, 1]);
        }

        return startDate;
    }

    const getFinancialYearEndDate = () => {
        let endDate = null;

        const selectedFinancialYear = getSelectFieldValue(financialYear.financialYear, financialYears);
        if (selectedFinancialYear) {
            endDate = moment([selectedFinancialYear.split(" - ")[1], 2, 31]);
        }

        return endDate;
    }

    const getCurrentFinancialYear = () => {
        const todayYear = moment().year();
        const todayMonth = moment().month();

        const startYear = todayMonth > moment().month("March").month() ? todayYear : todayYear - 1;
        const endYear = todayMonth > moment().month("March").month() ? todayYear + 1 : todayYear;

        return `${startYear} - ${endYear}`;
    }

    const financialYears = getFinancialYears();
    const defaultFinancialYear = [financialYears.length - 1];
    const currentFinancialYear = getCurrentFinancialYear();

    const states = IN_STATES.map(s => s.label);
    const countries = Countries.map(c => c.label);

    const getDefaultFieldConfig = (type, name, value, validation, options, readOnly, disabled, tooltip) => {
        return {
            type: type,
            name: name,
            value: value,
            validation: validation,
            invalid: false,
            errorMsg: null,
            options: options,
            readOnly: !!readOnly,
            disabled: !!disabled,
            tooltip: tooltip
        }
    }

    const regimeOptions = [
        {name: "Old Tax Regime", value: false},
        {name: "New Tax Regime", value: true}
    ];

    const initialFinancialYearState = {
        financialYear: getDefaultFieldConfig(INPUT_TYPE.DROPDOWN, "Financial Year", defaultFinancialYear, [["required"]], financialYears)
    };

    const initialRegimeState = {
        newRegime: getDefaultFieldConfig("radio", "Regime", false, [[]], regimeOptions)
    };

    const initialHouseRentState = {
        rentalFromDate: getDefaultFieldConfig(INPUT_TYPE.DATE, "From", null, [["required"]]),
        rentalToDate: getDefaultFieldConfig(INPUT_TYPE.DATE, "To", null, [["required"]]),
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Total Amount", "0", [["required"]]),
        addressLine1: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Address Line 1", null, [["required"]]),
        addressLine2: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Address Line 2", null, [[]]),
        zipCode: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Zipcode", null, [["required"]]),
        city: getDefaultFieldConfig(INPUT_TYPE.TEXT, "City", null, [["required"]]),
        state: getDefaultFieldConfig(INPUT_TYPE.SELECT, "State", null, [["required"]], states),
        country: getDefaultFieldConfig(INPUT_TYPE.SELECT, "Country", [104], [["required"]], countries, true),
        landlordName: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Landlord Name", null, [["required"]]),
        landlordPAN: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Landlord PAN", null, [["pattern", PAN_REGEX_PATTERN]], null, false, false, "The PAN should follow the pattern SSSSS0000S where S-Alphabet, 0-Number"),
        isMetroCity: getDefaultFieldConfig(INPUT_TYPE.CHECKBOX, "Metro", false, [[]], null, true)
    };

    const initialHomeLoanState = {
        homeLoanPrincipal: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Principal Paid on Home Loan", "0", [["required"]]),
        homeLoanInterest: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Interest Paid on Home Loan", "0", [["required"]]),
        lenderName: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Name of the Lender", null, [["required"]]),
        lenderPAN: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Lender PAN", null, [["required"], ["pattern", PAN_REGEX_PATTERN]])
    };

    const initialRentalIncomeState = {
        annualRentReceived: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Annual Rent Received", "0", [["required"]]),
        municipalTaxesPaid: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Municipal Taxes Paid", "0", [["required"]]),
        netAnnualValue: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Net Annual Value", null, [["required"]], null, true),
        standardDeduction: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Standard Deduction (@30% of Net Annual Value)", null, [["required"]], null, true),
        repayingHomeLoan: getDefaultFieldConfig(INPUT_TYPE.CHECKBOX, "Repaying Home Loan for this Property", true, [[]]),
        homeLoanPrincipal: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Principal Paid on Home Loan", "0", [["required"]]),
        homeLoanInterest: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Interest Paid on Home Loan", "0", [["required"]]),
        lenderName: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Name of the Lender", null, [["required"]]),
        lenderPAN: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Lender PAN", null, [["required"], ["pattern", PAN_REGEX_PATTERN]]),
        netIncomeLoss: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Net Income/Loss from House Property", "0", [["required"]], null, true)
    };

    const initialInvestmentState = {
        investment: getDefaultFieldConfig(INPUT_TYPE.SELECT, "Investment", null, [["required"]]),
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Amount", "0", [["required"]])
    };

    const initialOtherIncomeState = {
        otherIncomeSource: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Income from other sources", "0", [["required"]]),
        savingDepositInterest: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Interest Earned from Savings Deposit", "0", [["required"]]),
        fixedDepositInterest: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Interest Earned from Fixed Deposit", "0", [["required"]])
    };

    const [count, updateCount] = useState(1);
    const [showSection, setShowSection] = useState(false);
    const [declarationConfig, setDeclarationConfig] = useState(null);

    const [financialYear, setFinancialYear] = useState(initialFinancialYearState);
    const [newRegime, setNewRegime] = useState(initialRegimeState);
    const [houseRentEnabled, setHouseRentEnabled] = useState(false);
    const [houseRentState, setHouseRentState] = useState([]);
    const [homeLoanEnabled, setHomeLoanEnabled] = useState(false);
    const [homeLoanState, setHomeLoanState] = useState([]);
    const [rentalIncomeEnabled, setRentalIncomeEnabled] = useState(false);
    const [rentalIncomeState, setRentalIncomeState] = useState([]);
    const [investment80CState, setInvestment80CState] = useState([]);
    const [investment80DState, setInvestment80DState] = useState([]);
    const [otherInvestmentState, setOtherInvestmentState] = useState([]);
    const [otherIncomeState, setOtherIncomeState] = useState(initialOtherIncomeState);

    const [taxDeclarationItems, setTaxDeclarationItems] = useState([]);
    const [investment80CItems, setInvestment80CItems] = useState([]);
    const [investment80DItems, setInvestment80DItems] = useState([]);
    const [otherInvestmentItems, setOtherInvestmentItems] = useState([]);

    const [isEdit, setIsEdit] = useState(false);
    const [ITDeclarationData, setITDeclarationData] = useState(null);
    const [isLocked, setIsLocked] = useState(null);
    const [taxEstimate, setTaxEstimate] = useState(null);

    const [address, setAddress] = useState(null);
    const [viewportLarge, setIsViewportLarge] = useState(isViewportLarge());

    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            setIsViewportLarge(isViewportLarge())
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const forceUpdate = () => {
        updateCount(count + 1);
    }

    useEffect(() => {
        RouteManager.setPresenter({props: {...props, history: history}});

        if (!userId) {
            RouteManager.navigateToHome();
            return;
        }

        AppManager.scrollToTop();
        getITDeclarationConfig();
    }, []);

    useEffect(() => {
        if (isLocked !== null) {
            setShowSection(true);
        }
    }, [isLocked]);

    useEffect(() => {
        if (declarationConfig) {
            getITDeclaration();
        }
    }, [declarationConfig]);

    useEffect(() => {
        if (financialYear && declarationConfig) {
            getITDeclaration();
            resetData();
        }
    }, [financialYear]);

    useEffect(() => {
        if (taxDeclarationItems) {
            separateItemsIntoSections();
        }
    }, [taxDeclarationItems]);

    useEffect(() => {
        if (ITDeclarationData && investment80CItems && investment80CItems.length > 0) {
            setInvestmentData(setInvestment80CState, ITDeclarationData.investment80C, investment80CItems);
        }
    }, [investment80CItems]);

    useEffect(() => {
        if (ITDeclarationData && investment80DItems && investment80DItems.length > 0) {
            setInvestmentData(setInvestment80DState, ITDeclarationData.investment80D, investment80DItems);
        }
    }, [investment80DItems]);

    useEffect(() => {
        if (ITDeclarationData && otherInvestmentItems && otherInvestmentItems.length > 0) {
            setInvestmentData(setOtherInvestmentState, ITDeclarationData.otherExemptions, otherInvestmentItems);
        }
    }, [otherInvestmentItems]);

    useEffect(() => {
        if (ITDeclarationData) {
            getTaxDeclarationItems();
            setNewRegime({newRegime: { ...newRegime.newRegime, value: ITDeclarationData.newRegime}});
            setHouseRentData(ITDeclarationData.houseRents);
            setHomeLoanData(ITDeclarationData.homeLoanRepayment);
            setRentalIncomeData(ITDeclarationData.rentalIncome);
            setOtherIncomeData(ITDeclarationData.otherIncomeSources);
        } else {
            getTaxDetail();
        }
    }, [ITDeclarationData]);

    useEffect(() => {
        forceUpdate();
    }, [
        houseRentState,
        homeLoanState,
        rentalIncomeState,
        investment80CState,
        investment80DState,
        otherInvestmentState,
        otherIncomeState
    ]);

    const getTaxDeclarationItems = () => {
        INComplianceService.getTaxDeclarationItems().then(
            (response) => {
                removeLoader();
                if (response) {
                    setTaxDeclarationItems(response);
                }
            }, (error) => {
                removeLoader();
            }
        );
    }
    const getTaxDetail = () => {
        INTaxService.getTaxDetail().then(
            (response) => {
                removeLoader();
                if (response) {
                    setDefaultTaxRegime(response?.compliance?.defaultTaxRegime)
        }
            }, (error) => {
                removeLoader();
                setNewRegime({
                    newRegime: {
                        ...newRegime.newRegime, value: true
                    }
                });
            }
        );
    }
    const setDefaultTaxRegime = (defaultRegime) => {
        if (defaultRegime === "") {
            setNewRegime({ newRegime: { ...newRegime.newRegime, value: true } });
        } else {
            setNewRegime({
                newRegime: {
                    ...newRegime.newRegime, value:
                        defaultRegime == IN_TAX_REGIME_OPTIONS.NEW_TAX_REGIME
                }
            });
        }
    }
    const getEmployeeDetails = () => {
        const config = {
            ...EmployeeListService.apiConfig,
            getComponents: false,
            getCompliance: false,
            getBenefits: false,
            customFieldModule: "employee",
        };
        EmployeeListService.apiConfig = config;

        EmployeeListService.getEmployeeDetails(userId).then(
            (response) => {
                if (response.status === "OK") {
                    setAddress(response.user.address);
                }
            }
        );
    }

    const setIsLockedState = (isLocked) => {
        if (!isMyDeclaration && !PermissionUtils.hasAccess(MODULE.EMPLOYEE_DECLARATION, [ACTION.DRAFT, ACTION.SUBMIT])) {
            isLocked = true;
        }

        setIsLocked(isLocked);
    }

    const setLockUnlockStatus = (activeConfig, response) => {
        let locked = false;

        if (response.status === INVESTMENT_STATUS.SUBMITTED) {
            locked = true;
            showAlert("Alert", "Not allowed to edit submitted IT Declaration");
        } else if (activeConfig.declarationLockStatus) {
            locked = true;
            showAlert("Alert", "Time period to submit IT Declaration is locked");
        } else if (!(moment().startOf("day").isSameOrAfter(moment(activeConfig.declarationStartDate, DATE_FORMAT.YYYYMMDD))
            && moment().startOf("day").isSameOrBefore(moment(activeConfig.declarationEndDate, DATE_FORMAT.YYYYMMDD)))) {
            locked = true;
            showAlert("Alert", "IT Declaration is locked, Please contact your Admin.");
        } else if (Array.isArray(financialYear.financialYear.value) && currentFinancialYear != financialYear.financialYear.options[financialYear.financialYear.value[0]]) {
            locked = true;
        }

        setIsLockedState(locked);
    }

    const resetData = () => {
        setIsEdit(false);
        setIsLockedState(false);
        setITDeclarationData(null);

        setNewRegime(initialRegimeState);
        setHouseRentEnabled(false);
        setHouseRentState([]);
        setHomeLoanEnabled(false);
        setHomeLoanState([]);
        setRentalIncomeEnabled(false);
        setRentalIncomeState([]);
        setInvestment80CState([]);
        setInvestment80DState([]);
        setOtherInvestmentState([]);
        setOtherIncomeState(initialOtherIncomeState);
    }

    const getITDeclarationConfig = () => {
        showLoader();
        INComplianceService.getITDeclarationConfig().then(
            (configResponse) => {
                removeLoader();
                if (configResponse && configResponse.investmentConfig && configResponse.investmentConfig.declarationConfig) {
                    const declarationConfig = configResponse.investmentConfig.declarationConfig;
                    const activeConfig = declarationConfig.find(config => config.active && config.declarationStartDate !== "1900-01-01T00:00:00Z" && config.declarationEndDate !== "1900-01-01T00:00:00Z");
                    if (activeConfig) {
                        setDeclarationConfig(activeConfig);
                    } else {
                        setIsLockedState(true);
                        showAlert("Alert", "IT Declaration is locked, Please contact your Admin.");
                    }
                } else {
                    setIsLockedState(true);
                    showAlert("Alert", "IT Declaration is locked, Please contact your Admin.");
                }
            }, (error) => {
                removeLoader();
                setIsLockedState(true);
                showAlert("Alert", "IT Declaration is locked, Please contact your Admin.");
            }
        );
    }

    const getITDeclaration = () => {
        const params = {
            stage: INVESTMENT_STATUS.DECLARATION,
            financialYearStartDate: moment(getFinancialYearStartDate()).format(DATE_FORMAT.YYYYMMDD),
            userId: userId
        };
        showLoader();
        INComplianceService.getITDeclaration(params).then(
            (ITDeclarationResponse) => {
                removeLoader();
                if (ITDeclarationResponse) {
                    setIsEdit(true);
                    setITDeclarationData(ITDeclarationResponse);
                    setLockUnlockStatus(declarationConfig, ITDeclarationResponse);
                }
            }, (error) => {
                removeLoader();
                if (!address) {
                    getEmployeeDetails();
                }
                getTaxDeclarationItems();
                setLockUnlockStatus(declarationConfig, error);
            }
        );
    }

    const separateItemsIntoSections = () => {
        const investment80C = [];
        const investment80D = [];
        const otherInvestment = [];

        taxDeclarationItems.forEach((item) => {
            switch (item.section) {
                case "80C":
                case "80CC":
                case "80CCD(1)":
                    investment80C.push(item.value);
                    break;
                case "80D":
                    investment80D.push(item.value);
                    break;
                default:
                    if (["OTHER_INCOME","HOME_LOAN","HOUSE_RENT","RENTAL_INCOME"].indexOf(item.section) === -1) {
                        otherInvestment.push(item.value);
                    }
            }
        });

        setInvestment80CItems(investment80C);
        setInvestment80DItems(investment80D);
        setOtherInvestmentItems(otherInvestment);
    }

    const setSelectFieldValue = (config, options, searchField, valueField) => {
        let index;
        if (valueField) {
            if (searchField) {
                index = options.findIndex((item) => item[searchField] === valueField);
            } else {
                index = options.findIndex((item) => item === valueField);
            }

            config.value = [index];
        }
    }

    const setAmountValue = (config, amountDetails, taxItemKey) => {
        if (amountDetails && amountDetails.length > 0) {
            const index = amountDetails.findIndex((amountDetail) => amountDetail.name === taxItemKey);
            if (index !== -1) {
                config.value = amountDetails[index].declaredAmount;
                config.readOnly = isLocked;
            }
        }
    }

    const setHouseRentData = (houseRent) => {
        if (houseRent && houseRent.length > 0) {
            setHouseRentEnabled(true);

            const houseRentState = houseRent.map((rent) => {
                let state = deepClone(initialHouseRentState);
                state.rentalFromDate.value = moment(rent.rentalFromDate, DATE_FORMAT.YYYYMMDD).toDate();
                state.rentalToDate.value = moment(rent.rentalToDate, DATE_FORMAT.YYYYMMDD).toDate();
                setAmountValue(state.amount, rent.amountDetails, "HOUSE_RENT");
                state.addressLine1.value = rent.address.addressLine1;
                state.addressLine2.value = rent.address.addressLine2;
                state.zipCode.value = rent.address.zipCode;
                state.city.value = rent.address.city;
                setSelectFieldValue(state.state, IN_STATES, "value", rent.address.state);
                setSelectFieldValue(state.country, Countries, "value", rent.address.country);
                state.landlordName.value = rent.landlordName;
                state.landlordPAN.value = rent.landlordPAN;
                state.isMetroCity.value = rent.isMetroCity;

                return state;
            });

            setHouseRentState(houseRentState);

            if (houseRent[0] && houseRent[0].address) {
                setAddress(houseRent[0].address);
            }
        }
    }

    const setHomeLoanData = (homeLoan) => {
        if (homeLoan && homeLoan.length > 0) {
            setHomeLoanEnabled(true);

            const homeLoanState = homeLoan.map((loan) => {
                const state = deepClone(initialHomeLoanState);
                setAmountValue(state.homeLoanPrincipal, loan.amountDetails, "HOME_LOAN_PRINCIPLE");
                setAmountValue(state.homeLoanInterest, loan.amountDetails, "HOME_LOAN_INTEREST");
                state.lenderName.value = loan.lenderName;
                state.lenderPAN.value = loan.lenderPAN;

                return state;
            });

            setHomeLoanState(homeLoanState);
        }
    }

    const setRentalIncomeData = (rentalIncome) => {
        if (rentalIncome && rentalIncome.length > 0) {
            setRentalIncomeEnabled(true);

            const rentalIncomeState = rentalIncome.map((rental) => {
                const state = deepClone(initialRentalIncomeState);
                setAmountValue(state.annualRentReceived, rental.amountDetails, "ANNUAL_RENT");
                setAmountValue(state.municipalTaxesPaid, rental.amountDetails, "MUNICIPAL_TAXES");
                state.netAnnualValue.value = parseAmount(state.annualRentReceived.value) - parseAmount(state.municipalTaxesPaid.value);
                state.standardDeduction.value = parseAmount(state.netAnnualValue.value) * 0.3;
                state.repayingHomeLoan.value = rental.repayingHomeLoanForThisProperty;

                if (rental.repayingHomeLoanForThisProperty) {
                    setAmountValue(state.homeLoanPrincipal, rental.amountDetails, "PRINCIPLE_PAID_HOME_LOAN");
                    setAmountValue(state.homeLoanInterest, rental.amountDetails, "INTEREST_PAID_HOME_LOAN");
                    state.lenderName.value = rental.lenderName;
                    state.lenderPAN.value = rental.lenderPAN;
                    state.netIncomeLoss.value = parseAmount(state.netAnnualValue.value) - parseAmount(state.standardDeduction.value) - parseAmount(state.homeLoanInterest.value);
                } else {
                    clearValidation(state, ["homeLoanPrincipal", "homeLoanInterest", "lenderName","lenderPAN", "netIncomeLoss"]);
                }

                return state;
            });

            setRentalIncomeState(rentalIncomeState);
        }
    }

    const setInvestmentData = (setState, investments, investmentItems) => {
        if (investments && investments.amountDetails && investments.amountDetails.length > 0) {
            const investmentState = investments.amountDetails.map((investment) => {
                const state = deepClone(initialInvestmentState);
                const index = taxDeclarationItems.findIndex((item) => item.key === investment.name);
                if (index !== -1) {
                    setSelectFieldValue(state.investment, investmentItems, null, taxDeclarationItems[index].value);
                    setAmountValue(state.amount, investments.amountDetails, investment.name)
                }

                return state;
            });

            setState(investmentState);
        }
    }

    const setOtherIncomeData = (otherIncome) => {
        if (otherIncome && otherIncome.amountDetails && otherIncome.amountDetails.length > 0) {
            const state = deepClone(initialOtherIncomeState);
            setAmountValue(state.otherIncomeSource, otherIncome.amountDetails, "INCOME_OTHER_SOURCES");
            setAmountValue(state.savingDepositInterest, otherIncome.amountDetails, "SAVINGS_DEPOSIT_INTEREST");
            setAmountValue(state.fixedDepositInterest, otherIncome.amountDetails, "FIXED_DEPOSIT_INTEREST");

            setOtherIncomeState(state);
        }
    }

    const getSelectFieldValue = (config, options, searchField, valueField) => {
        let actualValue;
        if (searchField && valueField) {
            actualValue = options.find((item) => item[searchField] === config.options[config.value[0]])[valueField];
        } else {
            actualValue = options.find((item) => item === config.options[config.value[0]]);
        }

        return actualValue;
    }

    const getAmountDetails = (amount) => {
        const amountDetails = [];

        for (const [key, value] of Object.entries(amount)) {
            amountDetails.push({
                name: key,
                declaredAmount: parseAmount(value),
                actualAmount: 0,
                approvedAmount: 0,
                attachments: [],
                status: INVESTMENT_STATUS.PENDING
            });
        }

        return amountDetails;
    }

    const getHouseRentData = (houseRent) => {
        const houseRentData = [];

        houseRent.forEach((state) => {
            houseRentData.push({
                rentalFromDate: moment(state.rentalFromDate.value).format(DATE_FORMAT.YYYYMMDD),
                rentalToDate: moment(state.rentalToDate.value).format(DATE_FORMAT.YYYYMMDD),
                address: {
                    addressLine1: state.addressLine1.value,
                    addressLine2: state.addressLine2.value,
                    zipCode: state.zipCode.value,
                    city: state.city.value,
                    state: getSelectFieldValue(state.state, IN_STATES, "label", "value"),
                    country: getSelectFieldValue(state.country, Countries, "label", "value")
                },
                landlordName: state.landlordName.value,
                landlordPAN: state.landlordPAN.value,
                isMetroCity: state.isMetroCity.value,
                amountDetails: getAmountDetails({
                    "HOUSE_RENT": state.amount.value
                })
            });
        });

        return houseRentData;
    }

    const getHomeLoanData = (homeLoan) => {
        const homeLoanData = [];

        homeLoan.forEach((state) => {
            homeLoanData.push({
                lenderName: state.lenderName.value,
                lenderPAN: state.lenderPAN.value,
                amountDetails: getAmountDetails({
                    "HOME_LOAN_PRINCIPLE": state.homeLoanPrincipal.value,
                    "HOME_LOAN_INTEREST": state.homeLoanInterest.value
                })
            });
        });

        return homeLoanData;
    }

    const getRentalIncomeData = (rentalIncome) => {
        const rentalIncomeData = [];

        rentalIncome.forEach((state) => {
            const income = {
                netValue: state.netAnnualValue.value,
                deduction: state.standardDeduction.value,
                repayingHomeLoanForThisProperty: state.repayingHomeLoan.value
            }

            if (state.repayingHomeLoan.value) {
                income["lenderName"] = state.lenderName.value;
                income["lenderPAN"] = state.lenderPAN.value;
                income["netProfitLoss"] = state.netIncomeLoss.value;
                income["amountDetails"] = getAmountDetails({
                    "ANNUAL_RENT": state.annualRentReceived.value,
                    "MUNICIPAL_TAXES": state.municipalTaxesPaid.value,
                    "PRINCIPLE_PAID_HOME_LOAN": state.homeLoanPrincipal.value,
                    "INTEREST_PAID_HOME_LOAN": state.homeLoanInterest.value
                });
            } else {
                income["amountDetails"] = getAmountDetails({
                    "ANNUAL_RENT": state.annualRentReceived.value,
                    "MUNICIPAL_TAXES": state.municipalTaxesPaid.value
                });
            }

            rentalIncomeData.push(income);
        });

        return rentalIncomeData;
    }

    const getInvestmentData = (investments) => {
        const mapping = {};

        investments.forEach((state) => {
            if (state.investment.value && state.investment.value.length > 0) {
                const key = getSelectFieldValue(state.investment, taxDeclarationItems, "value", "key");
                mapping[key] = state.amount.value;
            }
        });

        return {
            amountDetails: getAmountDetails(mapping)
        }
    }

    const getPayload = () => {
        const payload = {
            userId: userId,
            financialYear: getSelectFieldValue(financialYear.financialYear, financialYears),
            newRegime: newRegime.newRegime.value,
            isHouseRentDetails: houseRentEnabled,
            isHouseRentalRepay: homeLoanEnabled,
            isHouseRentalIncome: rentalIncomeEnabled
        }

        if (houseRentEnabled) {
            payload["houseRents"] = getHouseRentData(houseRentState);
        }

        if (homeLoanEnabled) {
            payload["homeLoanRepayment"] = getHomeLoanData(homeLoanState);
        }

        if (rentalIncomeEnabled) {
            payload["rentalIncome"] = getRentalIncomeData(rentalIncomeState);
        }

        payload["investment80C"] = getInvestmentData(investment80CState);
        payload["investment80D"] = getInvestmentData(investment80DState);
        payload["otherExemptions"] = getInvestmentData(otherInvestmentState);

        payload["otherIncomeSources"] = {
            amountDetails: getAmountDetails({
                "INCOME_OTHER_SOURCES": otherIncomeState.otherIncomeSource.value,
                "SAVINGS_DEPOSIT_INTEREST": otherIncomeState.savingDepositInterest.value,
                "FIXED_DEPOSIT_INTEREST": otherIncomeState.fixedDepositInterest.value
            })
        };

        return payload;
    }

    const isInvalidITDeclaration = () => {
        let invalid = false;
        const states = [financialYear, newRegime, investment80CState, investment80DState, otherInvestmentState];

        if (houseRentEnabled) {
            states.push(houseRentState);
        }

        if (homeLoanEnabled) {
            states.push(homeLoanState);
        }

        if (rentalIncomeEnabled) {
            states.push(rentalIncomeState);
        }

        states.forEach((state) => {
            if (isInvalidState(state)) {
                invalid = true;
            }
        });

        return invalid;
    }

    const showConfirmDialog = () => {
        showAlert(
            "Confirm",
            "Please make sure all the details are accurate, you will not be able to edit once submitted. Do you want to proceed?",
            [
                {title: "Yes", className: "bg-app text-white mr-l", onClick: () => save(false)},
                {title: "No", className: "bg-app text-white"}
            ]
        );
    }

    const save = (isDraft) => {
        if (isInvalidITDeclaration()) {
            forceUpdate();
            return;
        }

        const payload = getPayload();

        const params = {
            stage: INVESTMENT_STATUS.DECLARATION,
            status: isDraft ? INVESTMENT_STATUS.DRAFT : INVESTMENT_STATUS.SUBMITTED,
            financialYearStartDate: moment(getFinancialYearStartDate()).format(DATE_FORMAT.YYYYMMDD)
        };

        const message = (isEdit ? "Updating" : "Saving") + "... Please wait"
        showLoader(message);
        if (!isEdit) {
            INComplianceService.saveITDeclaration(payload, params).then(
                (response) => {
                    removeLoader();
                    if (response) {
                        setIsEdit(true);

                        if (response.status === INVESTMENT_STATUS.SUBMITTED) {
                            setIsLockedState(true);
                        }

                        if (isDraft) {
                            showToast("IT Declaration saved as a draft.", TOAST_TYPE.SUCCESS);
                        } else {
                            showToast("IT Declaration saved successfully.", TOAST_TYPE.SUCCESS);
                        }
                    }
                }, (error) => {
                    removeLoader();
                }
            );
        } else {
            INComplianceService.updateITDeclaration(payload, params).then(
                (response) => {
                    removeLoader();
                    if (response) {
                        if (response.status === INVESTMENT_STATUS.SUBMITTED) {
                            setIsLockedState(true);
                        }

                        if (isDraft) {
                            showToast("IT Declaration updated as a draft.", TOAST_TYPE.SUCCESS);
                        } else {
                            showToast("IT Declaration updated successfully.", TOAST_TYPE.SUCCESS);
                        }
                    }
                }, (error) => {
                    removeLoader();
                }
            );
        }
    }

    const showPatternError = (validation, errorMsg, value) => {
        if (value !== null && value !== undefined && String(value).length !== 0) {
            const pattern = validation.findIndex((v) => v[0] === "pattern") !== -1;

            return pattern && (
                <DKLabel
                    className="fs-s text-red mt-s ml-xs"
                    style={{
                        marginTop: "-19px",
                        marginBottom: "8px"
                    }}
                    text={errorMsg}
                />
            )
        }
    }

    const isRequired = (validation) => {
        return validation.findIndex((v) => v[0] === "required") !== -1;
    }

    const getField = (section, state, index, property) => {
        let setState;

        switch (section) {
            case SECTION.FINANCIAL_YEAR:
                setState = setFinancialYear;
                break;
            case SECTION.REGIME:
                setState = setNewRegime;
                break;
            case SECTION.HOUSE_RENT:
                setState = setHouseRentState;
                break;
            case SECTION.HOME_LOAN:
                setState = setHomeLoanState;
                break;
            case SECTION.RENTAL_INCOME:
                setState = setRentalIncomeState;
                break;
            case SECTION.INVESTMENT_80C:
                setState = setInvestment80CState;
                break;
            case SECTION.INVESTMENT_80D:
                setState = setInvestment80DState;
                break;
            case SECTION.OTHER_INVESTMENT:
                setState = setOtherInvestmentState;
                break;
            case SECTION.OTHER_INCOME:
                setState = setOtherIncomeState;
                break;
        }

        switch (state[property].type) {
            case INPUT_TYPE.TEXT:
            case INPUT_TYPE.NUMBER:
            case INPUT_TYPE.DATE:
                return (
                    <>
                        <DKInput
                            title={state[property].name}
                            type={state[property].type}
                            className="pb-xl"
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            value={state[property].value}
                            errorMessage={state[property].errorMsg}
                            readOnly={!!state[property].readOnly || isLocked}
                            required={isRequired(state[property].validation)}
                            invalid={state[property].invalid}
                            canValidate={state[property].invalid}
                            onChange={(value) => {
                                updateState(section, setState, state, index, property, value);
                            }}
                        />
                        {state[property].invalid && showPatternError(state[property].validation, state[property].errorMsg, state[property].value)}
                    </>
                );
            case INPUT_TYPE.SELECT:
                return (
                    <>
                        <DKInput
                            title={state[property].name}
                            type={state[property].type}
                            className="pb-xl"
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            options={state[property].options}
                            value={state[property].value}
                            errorMessage={state[property].errorMsg}
                            readOnly={!!state[property].readOnly || isLocked}
                            required={isRequired(state[property].validation)}
                            invalid={state[property].invalid}
                            canValidate={state[property].invalid}
                            onChange={(value) => {
                                updateState(section, setState, state, index, property, value);
                            }}
                        />
                    </>
                )
            case INPUT_TYPE.DROPDOWN:
                return (
                    <DKInput
                        title={state[property].name}
                        type={state[property].type}
                        className="pb-xl"
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        dropdownConfig={{
                            allowSearch: state[property].options?.length > 7,
                            data: state[property].options,
                            renderer: (i, item) => item,
                            onSelect: (i, value) => {
                                updateState(section, setState, state, index, property, [i]);
                            }
                        }}
                        value={getSelectFieldValue(state[property], state[property].options)}
                        errorMessage={state[property].errorMsg}
                        readOnly={property === "financialYear" ? false : (!!state[property].readOnly || isLocked)}
                        required={isRequired(state[property].validation)}
                        invalid={state[property].invalid}
                        canValidate={state[property].invalid}
                        onChange={() => { }}
                    />
                )
            case INPUT_TYPE.CHECKBOX:
                return (
                    <div className="row" style={{ pointerEvents: state[property].readOnly || isLocked ? "none" : "initial" }}>
                        <DKCheckMark
                            className="pt-s pb-l"
                            isSelected={state[property].value}
                            onClick={() => {
                                updateState(section, setState, state, index, property, !state[property].value);
                            }}
                        />
                        <DKLabel className="pt-s pb-l ml-s" text={state[property].name} />
                    </div>
                )
            case "radio":
                return (
                    <div className="row" style={{ pointerEvents: state[property].readOnly || isLocked ? "none" : "initial" }}>
                        {state[property].options.map((o) => {
                            return (
                                <div key={o.value} className="row" style={{ width: "auto" }}>
                                    <input
                                        type="radio"
                                        name={property}
                                        style={{ margin: "0", marginRight: "5px" }}
                                        value={o.value}
                                        checked={o.value === state[property].value}
                                        onChange={() => {
                                            updateState(section, setState, state, index, property, o.value);
                                        }}
                                    />
                                    <DKLabel className="mr-l" text={o.name} />
                                </div>
                            )
                        })}
                    </div>
                )
        }
    }

    const getAddStateButton = (title, section, setState, newState, prevState) => {
        return (
            <div className={getDisableCSSClass("row mt-l", true)}>
                <DKButton
                    title={title}
                    className="bg-app text-white"
                    onClick={() => {
                        pushState(section, setState, newState, prevState);
                    }}
                />
            </div>
        )
    }

    const getEnableStateButton = (title, setState, state) => {
        return (
            <div className="row">
                <Toggle
                    className={getDisableCSSClass("mr-l", true)}
                    style={{width:'25%'}}
                    isOn={state}
                    onChange={() => {
                        setState(prevState => !prevState)
                    }}
                />
                <DKLabel style={{width:'75%'}} className="mb-xs " text={title} />
            </div>
        )
    }

    const getRemoveStateButton = (setState, index) => {
        return (
            <div className="ml-xl">
                <DKIcon
                    className="ic-s-2 cursor-hand"
                    src={ic_delete}
                    style={{
                        marginTop: "5px"
                    }}
                    onClick={() => {
                        popState(setState, index);
                    }}
                />
            </div>
        )
    }

    const enrichConfig = (state, property, extraConfig) => {
        state[property] = {...state[property], ...extraConfig};
        return state;
    }

    const isInvalidState = (state) => {
        let invalid = false;

        if (state) {
            if (Array.isArray(state)) {
                state.forEach((s) => {
                    for (const [key, fieldConfig] of Object.entries(s)) {
                        const error = hasError(fieldConfig.name, fieldConfig.value, fieldConfig.validation, fieldConfig.type);
                        s[key] = {...fieldConfig, ...error};
                        if (error.invalid) {
                            invalid = true;
                        }
                    }
                });
            } else {
                for (const [key, fieldConfig] of Object.entries(state)) {
                    const error = hasError(fieldConfig.name, fieldConfig.value, fieldConfig.validation, fieldConfig.type);
                    state[key] = {...fieldConfig, ...error};
                    if (error.invalid) {
                        invalid = true;
                    }
                }
            }
        }

        return invalid;
    }

    const pushState = (section, setState, newState, prevState) => {
        if (!isInvalidState(prevState)) {
            if (section === SECTION.HOUSE_RENT) {
                newState.rentalFromDate.value = getFinancialYearStartDate().toDate();
                newState.rentalToDate.value = getFinancialYearEndDate().toDate();

                if (address) {
                    newState.addressLine1.value = address.addressLine1;
                    newState.addressLine2.value = address.addressLine2;
                    newState.city.value = address.city;
                    newState.zipCode.value = address.zipCode;
                    newState.isMetroCity.value = (METRO_CITIES.indexOf(address.zipCode.substring(0, 3)) !== -1);
                    setSelectFieldValue(newState.state, IN_STATES, "value", address.state);
                    setSelectFieldValue(newState.country, Countries, "value", address.country);
                }
            }

            setState([...prevState, newState]);
        }

        forceUpdate();
    }

    const popState = (setState, index) => {
        setState((prevState) => {
            return index !== -1 ? prevState.filter((s, i) => i !== index) : [];
        });
    }

    const updateState = (section, setState, state, index, property, value) => {
        if (property === "financialYear") {
            setState((prevState) => {
                if (Array.isArray(prevState[property].value) && Array.isArray(value) && prevState[property].value[0] !== value[0]) {
                    const newConfig = {
                        ...state[property],
                        value: value,
                        ...hasError(state[property].name, value, state[property].validation, state[property].type)
                    };

                    return {...state, [property]: newConfig};
                }

                return prevState;
            });
        } else {
            setState((prevState) => {
                const newConfig = {
                    ...state[property],
                    value: value,
                    ...hasError(state[property].name, value, state[property].validation, state[property].type)
                };
    
                let newState;
                if (index === -1) {
                    newState = {...state, [property]: newConfig}
                } else {
                    newState = [...prevState];
                    newState[index] = {...state, [property]: newConfig};
                }
    
                if (section === SECTION.RENTAL_INCOME || section === SECTION.HOUSE_RENT) {
                    updateDependantFields(section, newState, index, property);
                }
    
                if (property === "investment" && (section === SECTION.INVESTMENT_80C || section === SECTION.INVESTMENT_80D || section === SECTION.OTHER_INVESTMENT)) {
                    if (isDuplicateState(prevState, property, value)) {
                        newState[index] = {...state, [property]: { ...state[property], value: null, invalid: true, errorMsg: "Investment is already selected, please select different" }};
                    }
                }
    
                return newState;
            });
        }
    }

    const isDuplicateState = (prevState, property, value) => {
        return prevState.findIndex((state) => Array.isArray(state[property].value) && Array.isArray(value) && state[property].value[0] === value[0]) !== -1;
    }

    const updateDependantFields = (section, newState, index, property) => {
        const state = newState[index];

        if (section === SECTION.RENTAL_INCOME) {
            if (property === "annualRentReceived" || property === "municipalTaxesPaid") {
                if (state["annualRentReceived"].value && state["municipalTaxesPaid"].value) {
                    updateField(state["netAnnualValue"], (parseAmount(state["annualRentReceived"].value) - parseAmount(state["municipalTaxesPaid"].value)));
                    updateField(state["standardDeduction"], (0.3 * (parseAmount(state["annualRentReceived"].value) - parseAmount(state["municipalTaxesPaid"].value))));
                } else {
                    updateField(state["netAnnualValue"], "");
                    updateField(state["standardDeduction"], "");
                }
            }

            if (state["repayingHomeLoan"].value && state["netAnnualValue"].value && state["standardDeduction"].value && state["homeLoanInterest"].value) {
                updateField(state["netIncomeLoss"], (parseAmount(state["netAnnualValue"].value) - parseAmount(state["standardDeduction"].value) - parseAmount(state["homeLoanInterest"].value)));
            } else {
                updateField(state["netIncomeLoss"], "");
            }

            if (property === "repayingHomeLoan") {
                if (!state["repayingHomeLoan"].value) {
                    clearValidation(state, ["homeLoanPrincipal", "homeLoanInterest", "lenderName","lenderPAN", "netIncomeLoss"]);
                } else {
                    setValidation(initialRentalIncomeState, state, ["homeLoanPrincipal", "homeLoanInterest", "lenderName","lenderPAN", "netIncomeLoss"]);
                }
            }
        }

        if (section === SECTION.HOUSE_RENT) {
            if (property === "zipCode") {
                if (state["zipCode"].value && state["zipCode"].value.length === 6) {
                    updateField(state["isMetroCity"], (METRO_CITIES.indexOf(state["zipCode"].value.substring(0, 3)) !== -1))
                } else {
                    updateField(state["isMetroCity"], false);
                }
            }

            if (property === "amount") {
                if (parseAmount(state["amount"].value) > 100000) {
                    state["landlordPAN"].validation = [["required"], ["pattern", PAN_REGEX_PATTERN]];
                } else {
                    state["landlordPAN"].validation = [["pattern", PAN_REGEX_PATTERN]]
                }
            }

            if ((property === "rentalFromDate" || property === "rentalToDate") && state["rentalFromDate"].value && state["rentalToDate"].value) {
                if (!moment(state["rentalFromDate"].value).isSameOrBefore(moment(state["rentalToDate"].value))) {
                    state[property].value = null;
                    state[property].invalid = true;
                    state[property].errorMsg = property === "rentalFromDate" ? "From date cannot be greater than To date" : "To date cannot be less than From date";
                }
                if (moment(state["rentalFromDate"].value).isBefore(getFinancialYearStartDate()) || moment(state["rentalFromDate"].value).isAfter(getFinancialYearEndDate())){
                    state[property].value = null;
                    state[property].invalid = true;
                    state[property].errorMsg = "Invalid From date";    
                }
                if (moment(state["rentalToDate"].value).isAfter(getFinancialYearEndDate()) || moment(state["rentalFromDate"].value).isBefore(getFinancialYearStartDate())){
                    state[property].value = null;
                    state[property].invalid = true;
                    state[property].errorMsg = "Invalid To date";    
                }
            }
        }
    }

    const updateField = (config, value) => {
        config["value"] = value;
        config["invalid"] = false;
        config["errorMsg"] = null;
    }

    const clearValidation = (state, fields) => {
        if (fields && fields.length > 0) {
            fields.forEach((field) => {
                state[field]["validation"] = [[]];
                state[field]["invalid"] = false;
                state[field]["errorMsg"] = null;
            });
        }
    }

    const setValidation = (initialState, state, fields) => {
        if (fields && fields.length > 0) {
            fields.forEach((field) => {
                state[field]["validation"] = initialState[field]["validation"];
                state[field]["invalid"] = false;
                state[field]["errorMsg"] = null;
            });
        }
    }

    const parseAmount = (number) => {
        return !isNaN(parseFloat(number)) ? parseFloat(number) : 0;
    }

    const hasError = (fieldName, value, validation, type) => {
        let error = {
            invalid: false,
            errorMsg: null
        };

        switch (type) {
            case INPUT_TYPE.SELECT:
                if (value && value.length === 0) {
                    value = null;
                }
                break;
        }

        if (validation.length !== 0) {
            validation.forEach((validation) => {
                switch (validation[0]) {
                    case "required":
                        if (value === null || value === undefined || String(value).trim() === "") {
                            error.invalid = true;
                            error.errorMsg = fieldName + " is required";
                        }
                        break;
                    case "pattern":
                        if (value && !new RegExp(validation[1]).test(value)) {
                            error.invalid = true;
                            error.errorMsg = "Invalid " + fieldName;
                        }
                        break;
                }
            });
        }

        return error;
    }

    const getDisableCSSClass = (initial, isButton) => {
        let CSSClass = initial || "";

        if (isLocked) {
            CSSClass += isButton ? " disable-button" : " disable-section";
        }

        return CSSClass;
    }

    const getFinancialYearAndTaxRegime = () => {
        return (
            <div>
                <div style={{ width: "200px" }}>
                    {getField(SECTION.FINANCIAL_YEAR, financialYear, -1, "financialYear")}
                </div>
                <div className={getDisableCSSClass("pb-xl", false)}>
                    {getField(SECTION.REGIME, newRegime, -1, "newRegime")}
                </div>
            </div>
        );
    }

    const getHouseRentDetails = (section, state, index) => {
        return (
            <div key={index}>
                {index !== 0 && <DKLine className="bg-gray3" />}
                <div className="row mt-l">
                    <div className="row align-items-start" style={{ width: width, marginRight: marginRight }}>
                        <div style={{ width: "45%", marginRight: "10%" }}>
                            {getField(section, state, index, "rentalFromDate")}
                        </div>
                        <div style={{ width: "45%" }}>
                            {getField(section, state, index, "rentalToDate")}
                        </div>
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "amount")}
                        </div>
                    </div>
                    {getRemoveStateButton(setHouseRentState, index)}
                </div>
                <div className="row">
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "addressLine1")}
                        </div>
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "addressLine2")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "zipCode")}
                        </div>
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "city")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "state")}
                        </div>
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "country")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "landlordName")}
                        </div>
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "landlordPAN")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    {getField(section, state, index, "isMetroCity")}
                </div>
            </div>
        );
    }

    const getHouseRentDetailsSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"House Rent Details"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {getEnableStateButton("Employee stays in a rented house", setHouseRentEnabled, houseRentEnabled)}
                    {houseRentEnabled && houseRentState.map((houseRent, index) => getHouseRentDetails(SECTION.HOUSE_RENT, houseRent, index))}
                    {houseRentEnabled && getAddStateButton("+ HOUSE RENT", SECTION.HOUSE_RENT, setHouseRentState, initialHouseRentState, houseRentState)}
                </div>
            </div>
        );
    }

    const getHomeLoanDetails = (section, state, index) => {
        return (
            <div key={index}>
                {index !== 0 && <DKLine className="bg-gray3" />}
                <div className="row mt-l">
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "homeLoanPrincipal")}
                        </div>
                    </div>
                    {getRemoveStateButton(setHomeLoanState, index)}
                </div>
                <div style={{ width: width }}>
                    <div>
                        {getField(section, state, index, "homeLoanInterest")}
                    </div>
                    <div>
                        {getField(section, state, index, "lenderName")}
                    </div>
                    <div>
                        {getField(section, state, index, "lenderPAN")}
                    </div>
                </div>
            </div>
        );
    }

    const getHomeLoanSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Home Loan Repayment Details"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {getEnableStateButton("Employee is repaying home loan for a self occupied house property", setHomeLoanEnabled, homeLoanEnabled)}
                    {homeLoanEnabled && homeLoanState.map((homeLoan, index) => getHomeLoanDetails(SECTION.HOME_LOAN, homeLoan, index))}
                    {homeLoanEnabled && getAddStateButton("+ HOME LOAN REPAYMENT", SECTION.HOME_LOAN, setHomeLoanState, initialHomeLoanState, homeLoanState)}
                </div>
            </div>
        )
    }

    const getRentalIncomeDetails = (section, state, index) => {
        return (
            <div key={index}>
                {index !== 0 && <DKLine className="bg-gray3" />}
                <div className="row mt-l">
                    <div style={{ width: width }}>
                        {getField(section, state, index, "annualRentReceived")}
                    </div>
                    {getRemoveStateButton(setRentalIncomeState, index)}
                </div>
                <div style={{ width: width }}>
                    <div>
                        {getField(section, state, index, "municipalTaxesPaid")}
                    </div>
                    <div>
                        {getField(section, state, index, "netAnnualValue")}
                    </div>
                    <div>
                        {getField(section, state, index, "standardDeduction")}
                    </div>
                    <div className="row">
                        {getField(section, state, index, "repayingHomeLoan")}
                    </div>
                    {state.repayingHomeLoan.value &&
                        <>
                            <div>
                                {getField(section, state, index, "homeLoanPrincipal")}
                            </div>
                            <div>
                                {getField(section, state, index, "homeLoanInterest")}
                            </div>
                            <div>
                                {getField(section, state, index, "lenderName")}
                            </div>
                            <div>
                                {getField(section, state, index, "lenderPAN")}
                            </div>
                            <div>
                                {getField(section, state, index, "netIncomeLoss")}
                            </div>
                        </>
                    }
                </div>
            </div>
        );
    }

    const getRentalIncomeSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Rental Income Details"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {getEnableStateButton("Employee is receiving rental income let out property", setRentalIncomeEnabled, rentalIncomeEnabled)}
                    {rentalIncomeEnabled && rentalIncomeState.map((rentalIncome, index) => getRentalIncomeDetails(SECTION.RENTAL_INCOME, rentalIncome, index))}
                    {rentalIncomeEnabled && getAddStateButton("+ LET OUT PROPERTY", SECTION.RENTAL_INCOME, setRentalIncomeState, initialRentalIncomeState, rentalIncomeState)}
                </div>
            </div>
        );
    }

    const getInvestmentDetails = (section, setState, state, index, options) => {
        return (
            <div key={index}>
                <div className="row mt-l">
                    <div style={{ width: width }}>
                        {getField(section, enrichConfig(state, "investment", {options: options}), index, "investment")}
                    </div>
                    <div className="ml-xxl" style={{ width: "20%" }}>
                        {getField(section, state, index, "amount")}
                    </div>
                    {getRemoveStateButton(setState, index)}
                </div>
            </div>
        );
    }

    const get80CInvestmentSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"80C Investments"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    <div className="row">
                        <DKIcon className="ic-s mr-s" src={ic_info_warning} />
                        <DKLabel className="fw-m text-gray" text={"This section contains the list of investments including LIC schemes, mutual funds and PPF. The maximum limit for this section is ₹150,000.00"} />
                    </div>
                    {showSection && investment80CState.map((investment, index) => getInvestmentDetails(SECTION.INVESTMENT_80C, setInvestment80CState, investment, index, investment80CItems))}
                    {getAddStateButton("+ 80C INVESTMENT", SECTION.INVESTMENT_80C, setInvestment80CState, initialInvestmentState, investment80CState)}
                </div>
            </div>
        );
    }

    const get80DInvestmentSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"80D Investments"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    <div className="row">
                        <DKIcon className="ic-s mr-s" src={ic_info_warning} />
                        <DKLabel className="fw-m text-gray" text={"This section contains Mediclaim policies for yourself, your children, spouse and parents. The maximum limit for this section is ₹100,000.00"} />
                    </div>
                    {showSection && investment80DState.map((investment, index) => getInvestmentDetails(SECTION.INVESTMENT_80D, setInvestment80DState, investment, index, investment80DItems))}
                    {getAddStateButton("+ 80D INVESTMENT", SECTION.INVESTMENT_80D, setInvestment80DState, initialInvestmentState, investment80DState)}
                </div>
            </div>
        );
    }

    const getOtherInvestmentSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Other Investments & Exemptions"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    <div className="row">
                        <DKIcon className="ic-s mr-s" src={ic_info_warning} />
                        <DKLabel className="fw-m text-gray" text={"Declare other investments & exemptions such as Voluntary NPS, Interest Paid on Education Loan and Medical Expenditures under this section."} />
                    </div>
                    {showSection && otherInvestmentState.map((investment, index) => getInvestmentDetails(SECTION.OTHER_INVESTMENT, setOtherInvestmentState, investment, index, otherInvestmentItems))}
                    {getAddStateButton("+ INVESTMENT", SECTION.OTHER_INVESTMENT, setOtherInvestmentState, initialInvestmentState, otherInvestmentState)}
                </div>
            </div>
        );
    }

    const getOtherIncomeDetails = (section, state, index) => {
        return (
            <div>
                <div style={{ width: viewportLarge ? width : "100%"}}>
                    {getField(section, state, index, "otherIncomeSource")}
                </div>
                <div style={{ width: viewportLarge ? width : "100%" }}>
                    {getField(section, state, index, "savingDepositInterest")}
                </div>
                <div style={{ width: viewportLarge ? width : "100%" }}>
                    {getField(section, state, index, "fixedDepositInterest")}
                </div>
            </div>
        )
    }

    const getOtherIncomeSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Other Sources of Income"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {showSection && getOtherIncomeDetails(SECTION.OTHER_INCOME, otherIncomeState, -1)}
                </div>
            </div>
        );
    }

    const getIincomeTaxCalculationPopup = () => {
        return (
            <div className="transparent-background">
                <div className="popup-window" style={{ padding: 24, maxWidth: "600px" }}>
                    <div className="popup-wrapper parent-width parent-height">
                        <DKLabel className="fs-xl fw-m" text={"Income Tax Calculated"} />
                        <DKLabel className="fs-m" text={"You can select amount the Old Tax Regime and New Tax Regime."} />
                        <div className="row mt-xxl mb-s">
                            <div
                                className={`p-l cursor-hand border-m border-radius-s ${taxEstimate.newRegime === false ? "border-green" : ""}`}
                                style={{
                                    width: "48%",
                                    marginRight: "4%"
                                }}
                                onClick={() => {
                                    setTaxEstimate({
                                        ...taxEstimate,
                                        newRegime: false
                                    });
                                }}
                            >
                                <DKLabel className="fs-r fw-m" text={"Old Tax Regime"} />
                                <DKLabel className="fs-xl fw-m" text={`Tax Liability: ${taxEstimate.amountOldRegime}`} />
                            </div>
                            <div
                                className={`p-l cursor-hand border-m border-radius-s ${taxEstimate.newRegime === true ? "border-green" : ""}`}
                                style={{ width: "48%" }}
                                onClick={() => {
                                    setTaxEstimate({
                                        ...taxEstimate,
                                        newRegime: true
                                    });
                                }}
                            >
                                <DKLabel className="fs-r fw-m" text={"New Tax Regime"} />
                                <DKLabel className="fs-xl fw-m" text={`Tax Liability: ${taxEstimate.amountNewRegime}`} />
                            </div>
                        </div>
                        <div className="row">
                            <DKIcon className="mr-s" src={ic_info_warning} />
                            <DKLabel text={"Please note that the tax liability is an estimate based on the current CTC."} />
                        </div>
                        <div className="row mt-xxl">
                            <DKButton
                                title={"CHANGE"}
                                className="bg-app text-white mr-l"
                                onClick={() => {
                                    updateState(SECTION.REGIME, setNewRegime, newRegime, -1, "newRegime", taxEstimate.newRegime);
                                    setTaxEstimate(null);
                                }}
                            />
                            <DKButton
                                title={"CANCEL"}
                                className="bg-app text-white"
                                onClick={() => {
                                    setTaxEstimate(null);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const getTaxEstimation = () => {
        const params = {
            financialYearStartDate: moment(getFinancialYearStartDate()).format(DATE_FORMAT.YYYYMMDD),
            userId: userId
        };
        showLoader();
        INComplianceService.getTaxEstimation(params).then(
            (response) => {
                removeLoader();
                if (response) {
                    setTaxEstimate({
                        ...response,
                        newRegime: newRegime.newRegime.value
                    });
                }
            }, (error) => {
                removeLoader();
            }
        );
    }

    const getCalculateIncomeTaxButton = () => {
        return (
            <div className="row mt-l">
                <DKButton
                    title={"CALCULATE INCOME TAX LIABILITY"}
                    className={getDisableCSSClass("bg-app text-white", true)}
                    onClick={() => {
                        getTaxEstimation();
                    }}
                />
            </div>
        )
    }

    const getActionButtons = () => {
        return (
            <div className="row mt-l">
                {(isMyDeclaration || PermissionUtils.hasAccess(MODULE.EMPLOYEE_DECLARATION, ACTION.SUBMIT)) &&
                    <DKButton
                        title={"SAVE AND SUBMIT"}
                        className={getDisableCSSClass("bg-app text-white mr-l", true)}
                        onClick={() => {
                            showConfirmDialog();
                        }}
                    />
                }
                {(isMyDeclaration || PermissionUtils.hasAccess(MODULE.EMPLOYEE_DECLARATION, [ACTION.DRAFT])) &&
                    <DKButton
                        title={"SAVE AS DRAFT"}
                        className={getDisableCSSClass("bg-app text-white mr-l", true)}
                        onClick={() => {
                            save(true);
                        }}
                    />
                }
                <DKButton
                    title={"CANCEL"}
                    className="bg-app text-white"
                    onClick={() => {
                        if (employeeData === "true") {
                            RouteManager.navigateToPage("/investments/employees-declaration", `stage=${INVESTMENT_STAGE.DECLARATION}`);
                        } else {
                            RouteManager.navigateToPage(PAGE_ROUTES.DASHBOARD);
                        }
                    }}
                />
            </div>
        )
    }

    const getITDeclarationForm = () => {
        return (
            <div className="pb-xl">
                {getFinancialYearAndTaxRegime()}
                {getHouseRentDetailsSection()}
                {getHomeLoanSection()}
                {getRentalIncomeSection()}
                {get80CInvestmentSection()}
                {get80DInvestmentSection()}
                {getOtherInvestmentSection()}
                {getOtherIncomeSection()}
                {getCalculateIncomeTaxButton()}
                {getActionButtons()}
            </div>
        );
    }

    const getEmployeeNameSection = () => {
        return (
            <div className="row p-v-l">
                <DKLabel className="fs-xl fw-m" text={employeeName} />
            </div>
        )
    }

    return (
        <div className="parent-width">
            {employeeName && getEmployeeNameSection()}
            {getITDeclarationForm()}
            {taxEstimate && getIincomeTaxCalculationPopup()}
        </div>
    );
}

export default MyITDeclaration;
